import { useEffect, useRef, useState } from 'react';
import { useUpdateNodeInternals } from 'reactflow';
import { select } from 'd3-selection';
import { drag } from 'd3-drag';
import throttle from 'lodash/throttle';

const MIN_ROTATE_STEP = 15;

const useRotation = (data, nodeId) => {
    const rotateControlRef = useRef(null);
    const updateNodeInternals = useUpdateNodeInternals();
    const [rotation, setRotation] = useState(data.rotation || 0);

    const applyRotation = throttle((newDeg) => {
        setRotation(newDeg);
        data.rotation = newDeg;
    }, 50);

    useEffect(() => {
        if (!rotateControlRef.current) {
            return;
        }

        const selection = select(rotateControlRef.current);
        const dragHandler = drag().on('drag', (evt) => {
            const dx = evt.x - 100;
            const dy = evt.y - 100;
            const rad = Math.atan2(dx, dy);
            const deg = rad * (180 / Math.PI);

            const newDeg = Math.round((180 - deg) / MIN_ROTATE_STEP) * MIN_ROTATE_STEP;

            applyRotation(newDeg);
            updateNodeInternals(nodeId);
        });

        selection.call(dragHandler);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nodeId, updateNodeInternals]);

    return [rotateControlRef, rotation];
};

export default useRotation;
